import { Component, effect, input, output, signal, ViewEncapsulation } from '@angular/core';
import { MarkdownModule } from 'ngx-markdown';
import { VideoPreviewComponent } from '../smart-fix-video-preview/smart-fix-video-preview.component';

@Component({
  selector: 'app-smart-fix-model-response',
  imports: [MarkdownModule, VideoPreviewComponent],
  standalone: true,
  templateUrl: './smart-fix-model-response.html',
  styleUrls: ['./smart-fix-model-response.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [],
})
export class ModelResponseComponent {
  content = input<string>('');
  isLoading = input<boolean>(false);

  blocks = signal<string[]>([]);
  reconstitutedText = signal<string>('');
  visible: boolean = false;
  showPreview = signal<boolean>(false);

  typingProgress = output<boolean>();

  constructor() {
    effect(() => {
      const newContent = this.content();
      if (newContent) {
        this.typeContent(newContent);
      }
    });
  }

  splitByWord(text: string): string[] {
    return text.split(' ');
  }

  typeContent(content: string) {
    const allBlocks = this.splitByWord(content);
    this.blocks.set([...allBlocks]);
    this.reconstitutedText.set('');
    this.showPreview.set(false);

    const typingInterval = setInterval(() => {
      const currentBlocks = this.blocks();
      if (currentBlocks.length > 0) {
        const nextWord = currentBlocks.shift();
        this.blocks.set(currentBlocks);
        this.reconstitutedText.update((prev) => prev + ' ' + nextWord);
        requestAnimationFrame(() => this.typingProgress.emit(true));
      } else {
        clearInterval(typingInterval);
        this.showPreview.set(true);
        requestAnimationFrame(() => this.typingProgress.emit(true));
      }
    }, 50);
  }
}
